export const SHOW_CUSTOM_ROLES = false; // Toggle to show/hide the custom roles section in the Permissions tab

export const MOCK_USERS = [
  { id: 1, name: "Dr. Sarah Johnson", email: "sarah.johnson@clinic.com", phone: "+1 555-0101", role: "Doctor" },
  { id: 2, name: "Emily Carter", email: "emily.carter@clinic.com", phone: "+1 555-0102", role: "Nurse" },
  { id: 3, name: "Michael Roberts", email: "m.roberts@clinic.com", phone: "+1 555-0103", role: "Admin" },
  { id: 4, name: "Dr. James Lee", email: "james.lee@clinic.com", phone: "+1 555-0104", role: "Doctor" },
  { id: 5, name: "Lisa Thompson", email: "lisa.t@clinic.com", phone: "+1 555-0105", role: "Nurse" },
  { id: 6, name: "Dr. Priya Sharma", email: "priya.sharma@clinic.com", phone: "+1 555-0106", role: "Doctor" },
];

export const ROLE_CHIP_STYLES = {
  admin: { backgroundColor: "#EEF2FF", color: "#5D5FEF", fontWeight: 600 },
  nurse: { backgroundColor: "#ECFDF5", color: "#059669", fontWeight: 600 },
  doctor: { backgroundColor: "#FFF7ED", color: "#D97706", fontWeight: 600 },
};

// Admin is deliberately excluded - orgs are limited to a single admin,
// assigned at signup, and this page shouldn't let anyone add another one
// or promote an existing user to it.
export const ROLE_OPTIONS = [
  { label: "Doctor", value: "doctor" },
  { label: "Nurse", value: "nurse" },
];

export const PREFIX_OPTIONS = [
  { label: "Dr.", value: "dr" },
  { label: "Mr.", value: "mr" },
  { label: "Ms.", value: "ms" },
  { label: "Mrs.", value: "mrs" },
];

export const PERMISSIONS = [
  { action: "Add users to the organization", admin: true, nurse: false, doctor: false },
  { action: "Assign roles to users", admin: true, nurse: false, doctor: false },
  { action: "Start a patient visit", admin: false, nurse: true, doctor: true },
  { action: "Record vitals and intake notes", admin: false, nurse: true, doctor: true },
  { action: "Assign a doctor to a visit", admin: false, nurse: true, doctor: false },
  { action: "Pause a visit", admin: false, nurse: true, doctor: true },
  { action: "Resume a visit", admin: false, nurse: true, doctor: true },
  { action: "Generate SOAP notes", admin: false, nurse: false, doctor: true },
  { action: "View SOAP notes", admin: false, nurse: false, doctor: true },
  { action: "Complete a visit", admin: false, nurse: false, doctor: true },
  { action: "Manage billing and licenses", admin: true, nurse: false, doctor: false },
  { action: "See diagnosis suggestions (CDSS)", admin: false, nurse: false, doctor: true },
];
